import React from 'react';
import classnames from 'classnames';
import partial from 'lodash/partial';
import {Link} from 'react-router-dom';
import {Dropdown, Header, Ref} from 'semantic-ui-react';
import {arrayOf, oneOf, shape, object, string, func, bool} from 'prop-types';
import * as ResourceApi from 'api/resources';
import {PluralResourceTypes} from './utils';
import {EmptyFunc} from 'utils/DBUtils';

export default class MasterSearchBar extends React.Component {
  static propTypes = {
    resultsRenderedElsewhere: bool.isRequired,
    router: shape({
      history: shape({push: func.isRequired}).isRequired
    }).isRequired,
    resourceType: string,
    fetching: bool,
    searchResults: arrayOf(object).isRequired,
    searchQueryChanged: func.isRequired,
    clearSearchResults: func.isRequired,
    startEditImage: func.isRequired
  };

  // render all options that have been passed in. otherwise, semantic will only render options whose
  // `text` properties match the input text.
  customSearchFilter = options => options;

  handleSearchChange = (e, {searchQuery}) => {
    if (!searchQuery.length) {
      this.props.clearSearchResults(this.props.resourceType);
    } else {
      this.props.searchQueryChanged(this.props.resourceType, searchQuery);
    }
  };

  handleChange = (e, {options}) => {
    if (e.key === 'Enter') {
      const firstValue = options[0].value;

      if (this.props.resourceType === ResourceApi.Types.Image) {
        this.props.startEditImage(firstValue);
      } else {
        const type = this.props.resourceType.toLowerCase();
        this.props.router.history.push(`/${type}/${firstValue}/edit${this.queryString}`);
      }
    }
  };

  get pluralResourceType() {
    return PluralResourceTypes[this.props.resourceType] || `${this.props.resourceType.toLowerCase()}s`;
  }

  get placeholderText() {
    return this.props.disabled ? '' : `Search for ${this.pluralResourceType}...`;
  }

  get noResultsMessage() {
    return this.props.resultsRenderedElsewhere ? '' : `No ${this.pluralResourceType} found.`;
  }

  get queryString() {
    return this.props.resourceType === ResourceApi.Types.Prize ? '?openSection=editPrizeSection' : '';
  }

  get className() {
    return classnames('header-master-search', {
      'hide-listbox': this.props.resultsRenderedElsewhere
    });
  }

  get options() {
    const type = this.props.resourceType.toLowerCase();

    return this.props.searchResults.map(resource => ({
      active: false,
      selected: false,
      key: resource.key,
      value: resource.id,
      text: resource.title,
      content: this.props.resourceType === ResourceApi.Types.Image ? (
        <Header
          onClick={partial(this.props.startEditImage, resource.id)}
          content={resource.title}
          subheader={resource.description} />
      ) : (
        <Link
          to={`/${type}/${resource.id}/edit${this.queryString}`}
          onClick={resource.onClick || EmptyFunc}>
          <Header content={resource.title} subheader={resource.description} />
        </Link>
      )
    }));
  }

  handleKeyDown = event => {
    if (event.key === 'Escape') {
      this.props.clearSearchResults(this.props.resourceType);
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, true);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, true);
  }

  render() {
    return (
      <Ref innerRef={this.handleRef}>
        <Dropdown
          className={this.className}
          icon='search'
          fluid
          selection
          // forceSelection={false}
          disabled={this.props.disabled}
          loading={this.props.fetching}
          options={this.options}
          search={this.customSearchFilter}
          onSearchChange={this.handleSearchChange}
          onChange={this.handleChange}
          placeholder={this.placeholderText}
          noResultsMessage={this.noResultsMessage} />
      </Ref>
    );
  }
}



// WEBPACK FOOTER //
// ./public/components/MasterSearchBar/MasterSearchBar.jsx